import React, { useState, useEffect } from "react";
import { BsMusicNoteList } from "react-icons/bs";
import loc03012026 from "../imgs/Locandine/Locandina18_04_2026 .jpeg";
import { FaMusic } from "react-icons/fa";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";

const Concerti = () => {
  const goNext = () => {
    setCurrentIndex((prev) => prev + 1);
  };

  const goPrev = () => {
    setCurrentIndex((prev) => prev - 1);
  };
  const [fullScreenImage, setFullScreenImage] = useState(null);

  const handleImageClick = (image) => {
    setFullScreenImage(image);
  };

  const handleClose = () => {
    setFullScreenImage(null);
  };

  const [currentIndex, setCurrentIndex] = useState(2);
  const [isTransitioning, setIsTransitioning] = useState(true);

  function importAll(r) {
    return r.keys().map(r);
  }

  const imagesModules = importAll(
    require.context("../imgs/Locandine", false, /\.(png|jpe?g|webp)$/),
  ).sort((a, b) => a.localeCompare(b));

  const sliderImages = imagesModules;

  const extendedImages = [
    sliderImages[sliderImages.length - 1],
    ...sliderImages,
    sliderImages[0],
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => prev + 1);
    }, 3000);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (currentIndex === extendedImages.length - 1) {
      setTimeout(() => {
        setIsTransitioning(false);
        setCurrentIndex(1);
      }, 700);
    }

    if (currentIndex === 0) {
      setTimeout(() => {
        setIsTransitioning(false);
        setCurrentIndex(extendedImages.length - 2);
      }, 700);
    }
  }, [currentIndex]);

  useEffect(() => {
    if (!isTransitioning) {
      requestAnimationFrame(() => {
        setIsTransitioning(true);
      });
    }
  }, [isTransitioning]);

  return (
    <div className="flex flex-col items-center  px-4 bg-gradient-to-r from-white to-amber-50">
      <BsMusicNoteList className="fixed text-amber-200/40 text-[180px] rotate-12 -top-5 -right-5 z-0" />

      <h1 className="text-red-600 font-extrabold text-3xl md:text-4xl mt-5 tracking-wide z-10">
        PROSSIMI CONCERTI
      </h1>

      <div
        className="relative w-[300px] sm:w-[40%] h-[350px] rounded-3xl shadow-xl 
  bg-white/60 backdrop-blur-xl border border-white/40 
  flex flex-col items-center justify-center overflow-hidden mt-3"
      >
        {/* Glow animato */}
        <div
          className="absolute inset-0 bg-gradient-to-br from-red-200/40 via-transparent to-amber-200/40 
    opacity-60 blur-2xl animate-pulse"
        ></div>

        {/* Cornice luminosa */}
        <div className="absolute inset-0 rounded-3xl border border-white/50 pointer-events-none"></div>

        {/* Icona */}
        <FaMusic className="text-6xl text-red-500 drop-shadow-lg mb-4 z-10 animate-bounce" />

        {/* Titolo */}
        <h2 className="text-3xl font-extrabold text-gray-800 tracking-wide z-10">
          Coming Soon
        </h2>

        {/* Sottotitolo */}
        <p className="text-sm mt-2 text-gray-600 z-10">
          Nuovi concerti in arrivo
        </p>

        {/* Barra animata */}
        <div className="mt-6 w-20 h-1.5 bg-red-500/70 rounded-full overflow-hidden z-10">
          <div className="h-full w-1/2 bg-white/80 animate-[loading_1.5s_infinite]"></div>
        </div>

        <style>
          {`
      @keyframes loading {
        0% { transform: translateX(-100%); }
        100% { transform: translateX(200%); }
      }
    `}
        </style>
      </div>

      {/* <div className="text-center text-lg mb-8 mt-5 z-10"></div>

      <div className="flex flex-row flex-wrap justify-center gap-6 w-full max-w-6xl mb-3">
        <div className="flex flex-col items-center justify-center w-[300px] sm:w-[40%] h-[350px] rounded-2xl shadow-xl bg-gradient-to-br from-white to-gray-100 text-gray-800 relative overflow-hidden">
          <div className="absolute w-40 h-40 bg-red-200 rounded-full blur-3xl opacity-40 animate-pulse"></div>
          <FaMusic className="text-5xl text-red-500 mb-4 z-10 animate-pulse" />
          <h2 className="text-2xl font-bold z-10 tracking-wide">Coming Soon</h2>
          <p className="text-sm mt-2 text-gray-500 z-10">
            Nuovi concerti in arrivo
          </p>
          <div className="mt-6 w-16 h-1 bg-red-500 rounded-full overflow-hidden z-10">
            <div className="h-full w-1/2 bg-white/60 animate-[loading_1.5s_infinite]"></div>
          </div>
          <style>
            {`
      @keyframes loading {
        0% { transform: translateX(-100%); }
        100% { transform: translateX(200%); }
      }
    `}
          </style>
        </div>
      </div> */}

      {fullScreenImage && (
        <div
          className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50"
          onClick={handleClose}
        >
          <img
            src={fullScreenImage}
            className="max-w-full max-h-full rounded-lg shadow-lg"
            alt="Ingrandimento"
          />
        </div>
      )}
      <h3 className="text-red-600 font-extrabold text-3xl md:text-4xl mt-5 tracking-wide z-10">
        I NOSTRI CONCERTI
      </h3>
      <div className="w-full max-w-2xl overflow-hidden mt-6 mb-4 relative">
        <FaChevronRight
          onClick={goNext}
          className="absolute right-2 top-1/2 -translate-y-1/2 z-20 text-2xl text-gray-600 hover:text-red-500 cursor-pointer transition"
        />
        <div
          className={`flex items-center ${
            isTransitioning
              ? "transition-transform duration-700 ease-in-out"
              : ""
          }`}
          style={{
            transform: `translateX(-${currentIndex * 33.33}%)`,
          }}
        >
          {extendedImages.map((img, index) => {
            const centerIndex = currentIndex + 1;
            const isCenter = index === centerIndex;
            return (
              <div
                key={index}
                className="flex-shrink-0 w-1/3 flex justify-center px-2"
              >
                <div
                  className={`transition-all duration-500 ${
                    isCenter ? "scale-105 opacity-100" : "scale-90 opacity-60"
                  }`}
                >
                  <img
                    src={img}
                    onClick={() => handleImageClick(img)}
                    className="h-[220px] w-auto object-contain rounded-lg shadow-lg cursor-pointer"
                    alt="locandina"
                  />
                </div>
              </div>
            );
          })}
        </div>
        <FaChevronLeft
          onClick={goPrev}
          className="absolute left-2 top-1/2 -translate-y-1/2 z-20 text-2xl text-gray-600 hover:text-red-500 cursor-pointer transition"
        />
      </div>
    </div>
  );
};

export default Concerti;
